<template>
  <VcitaSelectDropDown
    class="fee-type-method-selector"
    v-bind="$attrs"
    :value="computedValue"
    itemValue="key"
    itemText="title"
    @input="handleInput"
    item-color="none"
    :label="$t('payment.fee_type_select.label')"
    :menu-props="{contentClass: 'fee-type-selection-menu-content'}"
    :items="items">
    <template v-slot:item="{item, attrs, on}">
      <v-list-item
        :data-qa="item.key"
        :disabled="item.disabled"
        two-line
        v-bind="attrs"
        v-on="on"
        class="fee-type-item">
        <v-list-item-content>
          <v-list-item-title>
            <div class="fee-type-title">
              {{item.title}}
            </div>
          </v-list-item-title>
          <v-list-item-subtitle>
            <div class="fee-type-description">
              {{item.description}}
            </div>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>

    <template v-slot:selection="{item, attrs, on}" class="selection-container">
      <v-list-item
        v-bind="attrs"
        v-on="on"
        class="selected-item">
        <span class="fee-type-title"> {{item.title}} </span>
      </v-list-item>
    </template>

  </VcitaSelectDropDown>
</template>

<script>
import VcitaSelectDropDown from "@/modules/common/components/VcitaSelectDropDown/VcitaSelectDropDown.vue"
import {VSvgIcon} from "@/modules/common/components";

export default {
  name: "FeeTypeSelector",
  components: {
    VcitaSelectDropDown,
    VSvgIcon
  },
  props: {
    value: {
      type: String,
      required: true
    },
  },
  methods: {
    handleInput(val) {
      this.$emit('input', val)
    },
  },
  data() {
    return {
      chargeTypesMap: {
        no_price: 'free',
        free: 'free',
        discuss: 'discuss',
        paid_non_secured: 'paid',
        paid_force: 'paid',
        paid: 'paid',
      },
    }
  },
  computed: {
    computedValue() {
      return this.chargeTypesMap[this.value]
    },
    items() {
      const hasPaymentModuleFeatureFlag = this.$hasFeature('payments_module')
      return [
        {
          key: 'paid',
          title: this.$t('payment.fee_type_select.types.fixed_price.title'),
          description: this.$t('payment.fee_type_select.types.fixed_price.sub_title'),
          disabled: !hasPaymentModuleFeatureFlag,
        },
        {
          key: 'discuss',
          title: this.$t('payment.fee_type_select.types.custom_price.title'),
          description: this.$t('payment.fee_type_select.types.custom_price.sub_title'),
          disabled: !hasPaymentModuleFeatureFlag,
        },
        {
          key: 'free',
          title: this.$t('payment.fee_type_select.types.free.title'),
          description: this.$t('payment.fee_type_select.types.free.sub_title'),
        },
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
  .selected-item {
    min-height: 20px;
    padding: 0;
  }
  .method-item {
    min-height: 20px;
    padding: 12px;
    font-family: var(--primary-font-family);
    .fee-type-title {
      margin-top:3px;
      font-weight: 400;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.62);
    }
  }
  .fee-type-title {
    font-weight: 500;
  }
  .v-list-item__title {
    line-height: 20px;
  }
  .v-list-item__subtitle {
    text-overflow: initial;
    white-space: initial;
    font-size: 11px;
  }


</style>

<style lang="scss" >
  .fee-type-selection-menu-content {
    max-width: 412px;
  }
</style>
